import React from 'react'
import styled from 'styled-components'

import Container from '../Container'

interface PageHeaderProps {
  icon?: any
  subtitle?: string
  title?: string
  headerIcon? : object
}

const PageHeader: React.FC<PageHeaderProps> = ({ icon, subtitle, title, headerIcon }) => {

  return (
    <Container size="sm">
      <StyledPageHeader>
        <StyledIcon>{icon ? <img src={icon} /> 
        : <StyledImgScale>
          {headerIcon}
          </StyledImgScale>
        }
        </StyledIcon>
        <StyledTitle>{title}</StyledTitle>
        <StyledSubtitle>{subtitle}</StyledSubtitle>
      </StyledPageHeader>
    </Container>
  )
}

const StyledPageHeader = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding-bottom: ${(props) => props.theme.spacing[6]}px;
  padding-top: ${(props) => props.theme.spacing[6]}px;
  margin: 0 auto;
`

const StyledIcon = styled.div`
  font-size: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  width: 120px;
`

const StyledImgScale = styled.div`
  transform: scale(1.3)
`

const StyledTitle = styled.h1`
  // font-family: 'Kaushan Script', sans-serif;
  color: #fff;
  font-size: 36px;
  text-align: center;
  font-weight: 700;
  margin: 0;
  padding: 0;
`

const StyledSubtitle = styled.h3`
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  padding: 0;
  text-align: center;
`

export default PageHeader
